export const ADDRESS_VALIDATION_TOGGLE = 'address_validation';
export const CLIENTELING_CHAT_TOGGLE = 'clienteling_chat';
export const GLOBAL_NAV_HOME = 'global_nav_home_item';
export const PERFORMANCE_MODULE = 'performance_module';
export const PERFORMANCE_ASSOCIATE_SALES_AND_ENGAGEMENT = 'associate_sales_and_engagement';
export const PERFORMANCE_ASSOCIATE_NEW_ENGAGEMENT_WIDGET = 'new_engagement_widget_on_sa_performance_page';
export const PERFORMANCE_TODAYSALES = 'performance_todaysales';
export const STYLE_CENTRAL_TOGGLE = 'style_central';
export const CLIENT_NOTES = 'client_notes';
export const NOTIFICATION_POSTPONE_TOGGLE = 'notification_postpone';
export const GROUPS_MANAGEMENT = 'groups_management';
export const VOICE_CALLS_OUTBOUND = 'voice_calls_outbound';
export const NUMBER_PORT_ENABLED = 'phone_porting_done';
export const SMS_FUNCTIONALITY = 'sms_communication';
export const ORDER_ATTRIBUTION = 'order_attribution';
export const EMAIL_FUNCTIONALITY = 'email_communication';
export const BVD_PRODUCTS_LISTING = 'bvd_products_listing';
export const IN_STORE_PICKUP_PDP_INDICATOR = 'in_store_pickup_pdp_indicator';
export const CLIENT_NEW_GROUP_DETAILS_PAGE = 'clients_new_group_details_page';
export const BOPS_CURBSIDE_VERBIAGE = 'bops_curbside_verbiage';
export const EMAIL_ASSETS_ATTACHMENTS = 'email_assets_attachments';
export const STATEFUL_GLOBAL_NAV = 'stateful_global_nav';
export const GLOBAL_CLIENT_SEARCH_PROFILE_CREATION = 'global_client_search_profile_creation';
export const CONCIERGE_BAG_SHARING = 'concierge_bag_sharing';
export const MARKETING_SCRIPTS_EMAIL_SHARING = 'marketing_scripts_email_sharing';
export const CLIENT_BAG_SHARING = 'client_bag_sharing';
export const CUSTOM_GROUP_SELECTION_FOR_EMAIL = 'custom_group_selection_for_email';
export const RTC_CLIENT_ACTIONS = 'rtc_client_actions';
export const GROUP_FILTER_DEPT = 'group_filter_dept';
export const PLCC_PHASE2_LOYALTY_UPDATES = 'plcc_phase2_loyalty_updates';
export const EMAIL_RECIPIENT_LIMIT = 'email_recipient_limit';
export const RTC_PROGRESS_AND_FILTERS = 'rtc_progress_and_filters';
export const RTC_BADGES_FILTER = 'cc_filter_badges';
export const RTC_ASSETS_FILTER = 'sort_filter_promo_points_card';
export const ICE_CHECKOUT = 'ice_checkout';
export const NON_PLCC_AND_VIRTUAL_CARDS = 'non_plcc_and_virtual_cards';
export const PROMO_AND_POINTS = 'sort_filter_promo_points_card';
export const LOOKS_SHARING_CLICKABLE_LINKS = 'look_sharing_clickable_links';
export const REMINDERS = 'reminders';
export const EMAIL_SCRIPTS_PROMPT = 'email_prompt';
export const EMAIL_SIGNATURE = 'email_signature';
export const REMOVE_PRODUCT_SIZE_FROM_LOOK_SHARE_EMAIL = 'remove_product_size_from_look_share_email';
export const AUTO_APPLY_IN_CIRCLE_BENEFITS_IN_CHECKOUT = 'auto_apply_in_circle_benefits_in_checkout';
export const EMAIL_LOOK_SHARE = 'email_compose_look_attachment';
export const EXPANDED_ASSOCIATE_SCORECARD = 'new_scorecard_widget';
export const PRODUCT_SEARCH_BY_VENDOR = 'product_search_by_vendor';
export const PRODUCT_SHARE_TEMPLATE = 'connect_product_share_template';
export const PRODUCT_CATEGORY_BROWSE_CONTEXT = 'product_category_browse_context';
export const ASSOCIATE_ORDERS_V2 = 'associate_orders_api_v2';
export const ORDER_DETAILS_API_V2 = 'order_details_api_v2';
export const ALL_PDP_SWATCHES_CLICKABLE = 'all_pdp_swatches_clickable';
export const CLIENT_CONNECT_REDESIGN = 'client_connect_redesign';
export const MOVE_TO_CONCIERGE_CART = 'online_bag_move_to_concierge_cart';
